<template>
  <div class="nav-bar-menu">
    <ul class="flex menu-ul">
      <li v-for="(item, index) in menuList" :key="index" @click="cc(item)" :class="{
        'active-navbar': item.path === '/' ? nowPath === '/' : nowPath.startsWith(item.path),
        'en-font en-li': $i18n.locale == 'us_en' && swidth < 1600
      }">
        {{ item.title }}
      </li>
    </ul>
    <div class="navbar-lang flex">
      <span v-for="(item, index) in languageColumns" :class="[$i18n.locale == item.value ? 'active' : '',
      $i18n.locale == 'us_en' ? 'en-font' : '']" :key="index" @click="setLang(item.value)">{{ item.text }}</span>
      <!-- <span>简体</span>&nbsp;|&nbsp;<span>ENG</span> -->
    </div>
  </div>
</template>

<script>
// import { navbar } from "../common";
import { languageColumns } from '../../locale/utils'
import { setNowRoute } from '../../js/nowRoute'
export default {
  name: "Menu",
  props: {
    attr: Boolean,
    menuList: {
      type: Array,
      default: []
    },
    swidth: {
      type: Number,
      default: 1280
    },
  },
  computed: {
    activeIndex() {
      return this.$route.meta.active || this.$route.path;
    },
  },
  watch: {
    $route(val) {
      setNowRoute(val.name)
      this.nowPath = val.meta.active || val.path
    },
  },
  data() {
    return {
      nowPath: '/',
      languageColumns: languageColumns,
      lang: this.$i18n.locale,
    };
  },
  mounted() {
    this.nowPath = this.$route.meta.active || this.$route.path
  },
  methods: {
    setLang(item) {
      if (!item) return
      this.$i18n.locale = item
      localStorage.setItem('333f-locale-lang', item)
      location.reload()
    },
    handleMouseEnter() {
      this.isHovered = true;
    },
    handleMouseLeave() {
      this.isHovered = false;
    },
    cc(n) {
      if (n.title == "川云" || n.title == "chuanyun" || n.title == "Chuanyun") {
        window.open("https://cy.idea888.com/?tag=333f");
      } else {
        this.$router.push(n.path)
      }
    },
  },
};
</script>

<style scoped lang="less">
.nav-bar-menu {
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #fff;
  /* min-width: 600px;
  display: flex;
  position: absolute;
  right: 0;
  top: 0; */
}

.nav-bar-menu .active-navbar {
  height: 70px;
  border-bottom: 2px solid @primaryColor;
}

.nav-bar-menu .navbar-lang span {
  margin-left: 5px;
}

.navbar-lang {
  .active {
    color: @primaryColor;
    font-weight: 600;
  }
}

.nav-bar-menu .menu-ul {
  color: #fff;
  display: flex;
  margin-right: 30px;
  /* min-width: 550px; */
}

.nav-bar-menu .menu-ul li {
  padding: 0 20px 0;
  line-height: 70px;
  letter-spacing: 1px;
  white-space: nowrap;
}

.en-li {
  padding: 0 8px 0 3px !important;
}

.nav-bar-menu .menu-ul li:hover {
  /* background-color: antiquewhite; */
  height: 70px;
  border-bottom: 2px solid @primaryColor;
}
</style>



// WEBPACK FOOTER //
// src/components/navBar/Menu.vue